import React from "react";
import { StyledPageHeader } from "../styledComponent/styledHeader";
import Searchbar from "../searchbar/searchbar";
import { StyledButton } from "../styledComponent/styledElements";
import { CiEdit } from "react-icons/ci";

function PageTitle({
  title,
  subTitle,
  showSearch,
  onChange,
  value,
  showEdit,
  onEdit,
}) {
  return (
    <StyledPageHeader>
      {title && <span className="title-span">{title}</span>}
      {subTitle && <span className="sub-title-span">{subTitle}</span>}
      <div className="flex gap-3">
        {showSearch && <Searchbar onChange={onChange} value={value} />}
        {showEdit && (
          <StyledButton icon={<CiEdit size={20} />} onClick={onEdit}>
            Edit
          </StyledButton>
        )}
      </div>
    </StyledPageHeader>
  );
}

export default PageTitle;
